<!-- @format -->
@if (filterOptions()?.length > 10) {
    <div class="brand-input-container hmf-mb-s hmf-mt-xxxs">
        <!-- SEARCH BAR FOR BRAND -->
        <hmf-text-input
            type="text"
            class="search-brands-input"
            placeholder="Search Brands"
            inputStartIconName="search-outline"
            [disabled]="disabled()"
            [(ngModel)]="brandFilterString"
            (input)="brandInputChanged()">
        </hmf-text-input>
    </div>
}
<div
    class="checkbox-container hmf-position-relative hmf-pr-xxs"
    [class]="showMore() ? 'view-less' : 'view-more'"
    [class.popover-size]="!allowCollapsing()">
    @if(!brandFilterString() && allowCollapsing()){
        <!-- Remove 'Top Brands' for brands 10 and less and sort in alphabetically -->
		<!-- Brands return alphabetically from api -->
		@if (filterOptions()?.length > 10) {
	    	<div
				id="top-filters"
				class="hmf-mb-xxs hmf-body-bold-l">
		    		Top Brands
			</div>
		}

        @for (filterOption of topFilterOptions(); track trackFilterName(filterOption)) {
            <plp-components-filter-option
                class="hmf-mb-xxs"
                [filterOption]="filterOption"
                [attributeName]="attributeName()"
                [attributeIdentifier]="attributeIdentifier()"
                [ariaLabel]="getAriaLabel(filterOption)"
                [displayValue]="getDisplayValue(filterOption)"
                [isMobile]="isMobile()"
                [disabled]="disabled()"
                [selectedOptions]="selectedOptions()"
                (setSelectedFilter)="setSelectedFilter($event)"
                (setSelectedFilterWithSpace)="setSelectedFilterWithSpace($event.event, $event.value)">
            </plp-components-filter-option>
        }
    }
    @if(shouldRenderAlphabeticalList()){
        <div
            [class.hmf-display-none]="shouldHideHydratedList()">
            @for(row of visibleGroupedBrandRows(); track trackRow(row)){
                @if (row.type === 'header') {
                    <div
                        class="hmf-ml-xxxs hmf-mb-xxs hmf-subheader-bold-s">
                        {{ row.label }}
                    </div>
                } @else {
                    <plp-components-filter-option
                        [class]="!allowCollapsing() && row.isLast ? '' : 'hmf-mb-xxs'"
                        [filterOption]="row.option"
                        [attributeName]="attributeName()"
                        [attributeIdentifier]="attributeIdentifier()"
                        [ariaLabel]="row.ariaLabel"
                        [displayValue]="row.displayValue"
                        [isMobile]="isMobile()"
                        [disabled]="disabled()"
                        [selectedOptions]="selectedOptions()"
                        (setSelectedFilter)="setSelectedFilter($event)"
                        (setSelectedFilterWithSpace)="setSelectedFilterWithSpace($event.event, $event.value)">
                    </plp-components-filter-option>
                }
            }
        </div>

        @if(brandFilterString() && filteredOptionsResult()?.length === 0){
            <div
                class="empty-search-result hmf-body-m">
                No results found for '{{ brandFilterString() }}'
            </div>
        }
    }
</div>

@if (allowCollapsing() && hasOverflow() && !brandFilterString()) {
    <button
        hmf-action-text
        variant="secondary"
        (click)="toggleShowMore()">
        {{ showMore() ? 'View Less' : 'View All Brands +' }}
    </button>
}